/**
 * Helper utility functions for content conditions and change handling
 */
import { debugLog } from "./index";

/**
 * Creates a status object for change tracking and conditions
 * Replacement for the removed checkChangedData function
 * 
 * @param {Number|Boolean} changedType - A flag or number indicating change status
 * @param {String} message - Optional message explaining the change or condition
 * @returns {Object} Status object with status and message
 */
export function createStatusInfo(changedType, message = "") {
  return {
    status: Boolean(changedType),
    msg: message
  };
}

/**
 * Combines condition information with change information
 * 
 * @param {Object} conditionInfo - Information about conditions
 * @param {Object} changeInfo - Information about changes
 * @returns {Object} Combined status object
 */
export function combineStatusInfo(conditionInfo, changeInfo) {
  // If both have messages, combine them
  let combinedMessage = "";
  
  if (conditionInfo.msg && changeInfo.msg) {
    combinedMessage = `${conditionInfo.msg}; ${changeInfo.msg}`;
  } else {
    combinedMessage = conditionInfo.msg || changeInfo.msg;
  }
  
  return {
    status: conditionInfo.status || changeInfo.status,
    msg: combinedMessage
  };
}

/**
 * Creates a status object based on condition evaluation
 * 
 * @param {Boolean} shouldHide - Whether the content should be hidden
 * @param {String} conditionSummary - Summary of the conditions
 * @returns {Object} Status object for the condition
 */
export function createConditionStatusInfo(shouldHide, conditionSummary) {
  return {
    status: shouldHide,
    msg: conditionSummary
  };
}

export default {
  createStatusInfo,
  combineStatusInfo,
  createConditionStatusInfo
};